/**
 * @import { Filters } from '../types/filters'
 */

import { monthOptions } from './filters';

/**
 * @param {number[]} months
 * @param {number} [year]
 * @returns {string[]}
 */
function getFormattedFilterMonths(months, year) {
  return months.map((month) => {
    const monthLabel = monthOptions.find((option) => option.value === month)?.label.toLowerCase() ?? '';
    return year != null ? `${year}_${monthLabel}` : monthLabel;
  });
}

/**
 * @param {Filters} filters
 * @returns {string}
 */
function formatDepartureDateFilter(filters) {
  const dateFilters = filters.years.length
    ? filters.years.flatMap((year) =>
        filters.months.length ? getFormattedFilterMonths(filters.months, year) : year.toString()
      )
    : getFormattedFilterMonths(filters.months);
  return dateFilters.join('|');
}

/**
 * @param {Filters} filters
 * @returns {string}
 */
function formatDurationDays(filters) {
  return filters.durations
    .map((duration) => `${[duration.min, duration.max].filter((value) => value !== 0).join('_')}_days`)
    .join('|');
}

/**
 * @param {Filters} filters
 * @param {number} resultCount
 */
export function getFiltersAnalyticAttributes(filters, resultCount) {
  return {
    'tl-voyage_filter': filters.cruises.join('|'),
    'tl-departure_date_filter': formatDepartureDateFilter(filters),
    'tl-duration_filter': formatDurationDays(filters),
    'tl-number_results': resultCount,
  };
}
